module.exports = __webpack_public_path__ + "img/resource.b543feca.png";